var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("InformationWrapper", {
    scopedSlots: _vm._u([
      {
        key: "primary",
        fn: function () {
          return [
            _c(
              "InformationCard",
              { attrs: { title: "Background" } },
              [
                _c(
                  "CardBodyItem",
                  {
                    attrs: {
                      label: "Skills",
                      totalNumber: _vm.managerSkills.length,
                    },
                  },
                  [
                    _vm.managerSkills.length > 0
                      ? _c("ItemChipsWithMore", {
                          attrs: { items: _vm.managerSkills, limit: 100 },
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "font-normal text-base text-gray-new",
                          },
                          [_vm._v(" No skills added. ")]
                        ),
                  ],
                  1
                ),
                _c(
                  "CardBodyItem",
                  { attrs: { label: "About" } },
                  [
                    _vm.about
                      ? _c("FormattedDescription", {
                          attrs: { content: _vm.about },
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "font-normal text-base text-gray-new",
                          },
                          [_vm._v(" No about added. ")]
                        ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "LoadingOverlay",
                      {
                        attrs: {
                          hasData: !!_vm.projects,
                          loading: _vm.$apollo.queries.projects.loading,
                        },
                      },
                      [
                        [
                          _c("div", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg",
                              },
                              [
                                _vm._v(" Closed Clients "),
                                _vm.completedProjects &&
                                _vm.completedProjects.length > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-gray-new text-base font-normal text-sm ml-0.5",
                                      },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.completedProjects.length
                                            ) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm.empty
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No closed clients added. ")]
                              )
                            : _vm._e(),
                          _c("ProjectCollection", {
                            attrs: {
                              projects: _vm.projects,
                              companyId: _vm.companyId,
                              currentUser: _vm.currentUser,
                              canEdit: "",
                            },
                            on: { projectUpdated: _vm.handleRefetch },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }